<input
    #input
    nz-input
    type="text"
    maxlength="10"
    class="a-text-cap1"
    [class.error]="hasError && input?.value"
    [class.selected]="selected"
    [placeholder]="dateFormat"
    nz-tooltip
    nzTooltipTrigger="focus"
    [nzTooltipTitle]="tooltip"
    [nzTooltipPlacement]="tooltipPlacement"
    [ngModel]="date | formatDate: dateFormat"
    (keypress)="onKeypressEvent($event)"
    (keyup)="onKeyupEvent($event)"
/>
